/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tab, Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import TabList from '@material-ui/lab/TabList';
import { usersAPI } from 'src/api/modules/users';
import TabPanel from '@material-ui/lab/TabPanel';
import notice from 'src/common/components/Notice';
import TabContext from '@material-ui/lab/TabContext';
import { sessionsAPI } from 'src/api/modules/sessions';
import { bitacoraApi } from 'src/api/modules/bitacora';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import {
	columnsMember,
	columnsPreviousSessions,
	columnsUpcomingSessions,
} from './utils/list_data';

const StartDetail = () => {
	const history = useHistory();
	const [users, setUsers] = useState([]);
	const [value, setValue] = React.useState('1');
	const [previousSessions, setPreviousSessions] = useState([]);
	const [upcomingSessions, setUpcomingSessions] = useState([]);
	const organo = useSelector((state) => state.organos.organo);

	useEffect(() => {
		getDataFromApiUsers();
		getDataFromApiSessions();
		getUpcomingSessions();
		bitacoraApi.post({
			accion:
				'Visualizo miembros pertenecientes al organo colegiado ' + organo.nombre,
		});
	}, []);

	const getDataFromApiUsers = () => {
		usersAPI
			.getUsersByOrgan(organo.id)
			.then((response) => {
				if (response.usuarios && response.usuarios.length > 0) {
					let users = response.usuarios.filter(
						(item) => item.cargo !== '' && item.cargo !== 'TI'
					);
					let usersName = [];
					users.forEach((item) => {
						usersName.push({
							nombre: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
							cargo:
								item.sector === ''
									? item.cargo === 'PR'
										? 'Propietario'
										: item.cargo === 'SU'
										? 'Suplente'
										: item.cargo === 'SUP'
										? 'Suplente'
										: item.cargo === 'TI'
										? 'Titular'
										: item.cargo
									: item.sector !== ''
									? (item.cargo === 'PR'
											? 'Propietario'
											: item.cargo === 'SU'
											? 'Suplente'
											: item.cargo === 'SUP'
											? 'Suplente'
											: item.cargo === 'TI'
											? 'Titular'
											: item.cargo) +
									  ' - ' +
									  (item.sector === 'SG'
											? 'Sector Gobierno'
											: item.sector === 'ST'
											? 'Sector Trabajador'
											: item.sector === 'SE'
											? 'Sector Empresarial'
											: item.sector === undefined
											? 'Sin Sector'
											: item.sector)
									: '',
						});
					});

					setUsers(usersName);
				} else {
					notice('No se encontraron resultados', 'info');
					setUsers([]);
				}
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'info');
			});
	};

	const getDataFromApiSessions = () => {
		setPreviousSessions([]);
		sessionsAPI
			.getPreviousSessionsByOrgan(organo.id)
			.then((response) => {
				if (response.length > 0) {
					let respOrderly = response.sort((a, b) => {
						var partes = a.fecha.split('-');
						var fa = new Date(partes[2], partes[1], partes[0]);
						partes = b.fecha.split('-');
						var fb = new Date(partes[2], partes[1], partes[0]);

						return fb - fa;
					});

					setPreviousSessions(respOrderly);
				}
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'info');
			});
	};

	const getUpcomingSessions = () => {
		setUpcomingSessions([]);
		sessionsAPI
			.getUpcomingSessionsByOrgan(organo.id)
			.then((response) => {
				let newsessions = [];
				if (response.length > 0) {
					let respOrderly = response.sort((a, b) => {
						var partes = a.fecha.split('-');
						var fa = new Date(partes[2], partes[1], partes[0]);
						partes = b.fecha.split('-');
						var fb = new Date(partes[2], partes[1], partes[0]);

						return fb - fa;
					});

					respOrderly.forEach((r) => {
						newsessions.push({
							id: r.id,
							hourAndDate: ` ${r.fecha}, ${r.hora}`,
							organAndSession: ` ${organo.nombre} >> Número de sesión ${r.numero_sesion} `,
						});
					});

					setUpcomingSessions(newsessions);
				}
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'info');
			});
	};

	const onOrderOTDay = (id) =>
		history.push(`/sesiones/consultar-sesiones/sesion/${id}`);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		let menssage;
		if (newValue === '1')
			menssage = `Visualizo sesiones anteriores del órgano colegiado ${organo.nombre}`;
		if (newValue === '2')
			menssage = `Visualizo sesiones próximas del órgano colegiado ${organo.nombre}`;
		if (newValue === '3')
			menssage = `Visualizo miembros pertenecientes al órgano colegiado ${organo.nombre}`;

		bitacoraApi.post({ accion: menssage });
	};

	return (
		<PageLayout>
			<Box sx={{ width: '100%', typography: 'body1' }}>
				<TabContext value={value}>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<TabList onChange={handleChange}>
							<Tab label="Sesiones Anteriores" value="1" />
							<Tab label="Sesiones Próximas" value="2" />
							<Tab label="Miembros" value="3" />
						</TabList>
					</Box>
					<TabPanel value="1">
						<FullTable
							title="Sesiones Anteriores"
							items={previousSessions}
							columns={columnsPreviousSessions(onOrderOTDay)}
						/>
					</TabPanel>
					<TabPanel value="2">
						{upcomingSessions.length > 0 ? (
							<FullTable
								title="Sesiones Próximas"
								items={upcomingSessions}
								columns={columnsUpcomingSessions(onOrderOTDay)}
							/>
						) : (
							<div
								style={{
									fontSize: '15px',
									color: '#A1A5B6',
									textAlign: 'center',
								}}
							>
								Por el momento no hay próximas sesiones.
							</div>
						)}
					</TabPanel>
					<TabPanel value="3">
						<FullTable
							title="Miembros"
							items={users}
							columns={columnsMember}
						/>
					</TabPanel>
				</TabContext>
			</Box>
		</PageLayout>
	);
};

export default StartDetail;
